<template>
  <div
    class="form-group intl-phone"
    :class="{
      'form-group--error':
        typeof validate !== 'undefined' &&
        validate.$dirty &&
        !validate.$pending &&
        validate.$invalid,
    }"
  >
    <label
      >{{ label }} <span class="text-danger" v-if="isRequired"> * </span></label
    >
    <vue-tel-input
      v-model="phone"
      class="p-inputtext p-component form-control contact-phone"
      :class="{
        'p-invalid':
          typeof validate !== 'undefined' &&
          validate.$dirty &&
          !validate.$pending &&
          validate.$invalid,
      }"
      styleClass="p-inputtext p-component form-control contact-phone"
      defaultCountry="US"
      :autoFormat="true"
      mode="international"
      :inputOptions="inputOptions"
      :dropdownOptions="dropdownOptions"
      @validate="validatePhoneNumber($event)"
    ></vue-tel-input>
    <span class="invalid-phone" v-if="!isValidPhone && phone.length"
      >Invalid phone number</span
    >
    <BaseFormMessage
      v-if="typeof validate !== 'undefined'"
      :validate="validate"
      :label="label"
    />
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: false,
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
    validate: {
      type: Object,
      default: () => {
        // This is intentional
      },
    },
  },
  data() {
    return {
      isValidPhone: true,
      inputOptions: {
        maxlength: 16,
      },
      dropdownOptions: {
        showSearchBox: true,
        showFlags: true,
      },
    };
  },
  watch: {
    isValidPhone(val) {
      this.$emit("isValidPhone", val);
    },
  },
  computed: {
    phone: {
      get: function () {
        return this.value;
      },
      // setter
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    validatePhoneNumber(phoneNumber) {
      this.isValidPhone = phoneNumber.valid;
    },
  },
};
</script>
